import logger from '../lib/logger'

/**
 * RequiresNoAuth may be placed in front of a page to enforce that only un-authed
 * users can access the page.  If an authenticated user attempts to access the page,
 * they are instead redirected to either `app_return_path` provided in the query,
 * or `/editor`.
 *
 * In addition, any query params provided to the original page will remain intact.
 */
export default async function({ redirect, query, app }) {
  if (process.static) return

  logger.debug('requires-no-auth: Checking user authentication')
  try {
    const auth = await app.$getAuthInstance()
    await auth.currentAuthenticatedUser()

    redirect({
      path: query.app_return_path || '/dashboard/latest',
      query,
    })
  } catch (e) {
    logger.debug('requires-no-auth: user not authenticated, allowing access')
  }
}
